import { AxiosResponse } from "axios";
import { coreAuthUrls } from "../../url";
import { taxGuruAxios } from "../../axios";
import {
    AuthRequest,
    AuthResponse,
    RefreshTokenResponse,
    ResetPasswordConfirmationRequest,
    ResetPasswordRequest,
} from "@mm-products/java-multima-framework";

export const loginRequest = (request: AuthRequest): Promise<AxiosResponse<AuthResponse>> => {
    return taxGuruAxios.post(coreAuthUrls.login, request);
};

export const logoutRequest = (): Promise<AxiosResponse<unknown>> => {
    return taxGuruAxios.post(coreAuthUrls.logout);
};

export const refreshAccessToken = (caller = taxGuruAxios): Promise<AxiosResponse<RefreshTokenResponse>> => {
    return caller.post(coreAuthUrls.refreshToken);
};

export const requestPasswordReset = (req: ResetPasswordRequest, medium = "email"): Promise<AxiosResponse<void>> => {
    return taxGuruAxios.post(coreAuthUrls.resetPassword, req, { params: { medium } });
};
export const requestPasswordVerify = (token: string, medium = "email"): Promise<AxiosResponse<void>> => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return taxGuruAxios.post(coreAuthUrls.resetPasswordVerify, undefined, { params: { medium, token }, noErrorToast: true });
};
export const confirmPasswordReset = (req: ResetPasswordConfirmationRequest, medium = "email"): Promise<AxiosResponse<void>> => {
    return taxGuruAxios.post(coreAuthUrls.resetPasswordConfirm, req, { params: { medium } });
};
